// extracted by mini-css-extract-plugin
export default {"container":"telephony_container__ERWRv"};